(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7477],{

/***/ 48625:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/pd/[model]/[id]/personalise",
      function () {
        return __webpack_require__(60385);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(3204);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var gql_queries_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32952);
/* harmony import */ var gql_queries_category__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4197);
/* harmony import */ var utils_breadcrumbRedirects__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5567);
/* harmony import */ var sites__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49201);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79758);
/* harmony import */ var utils_locale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79302);
/* harmony import */ var ui_components_Page__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87150);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77480);
/* harmony import */ var ui_components_PageHead__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9294);
/* harmony import */ var hooks_usePdp__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41316);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20368);
/* harmony import */ var ui_pages_ProductDetailsPages__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36085);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15550);
/* harmony import */ var ui_components_ProductStory__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71759);
/* harmony import */ var ui_components_PixleeProductWidget__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6411);
/* harmony import */ var hooks_useProductCustomization__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70880);
/* harmony import */ var hooks_useMiniCart__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38859);
/* harmony import */ var ui_components_MiniCart__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(65656);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(53625);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37678);
/* harmony import */ var ui_components_SanityContentSlot__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(54331);
/* harmony import */ var utils_object__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(7676);
/* harmony import */ var ui_elements_InjectedScript__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(19735);
/* harmony import */ var hooks_useIsServer__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(64724);

































var VARIANT_ID_MIN_LENGTH = 12; // variant IDs will be 12+ digits long
/** Checks if the length of the given `id` is gte `VARIANT_ID_MIN_LENGTH`. */ var isVariantId = function(id) {
    return id.length >= VARIANT_ID_MIN_LENGTH;
};
var Personalise = function() {
    var ref, ref1, ref2;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_10__/* .useTranslate */ .qM)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref3 = (0,hooks_usePdp__WEBPACK_IMPORTED_MODULE_12__/* .usePdp */ .Y)(), masterProduct = ref3.masterProduct, variation = ref3.variation, content = ref3.content;
    var ref4 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_13__/* .useSiteConfig */ .N)(), currency = ref4.currency, host = ref4.host;
    var personalizationEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_21__/* .useFeature */ .S)("PERSONALIZATION_ENABLED");
    var reviewsEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_21__/* .useFeature */ .S)("RATINGS_AND_REVIEWS");
    var isMiniCartVisible = (0,hooks_useMiniCart__WEBPACK_IMPORTED_MODULE_19__/* .useMiniCart */ .lm)().isMiniCartVisible;
    var _$isServer = (0,hooks_useIsServer__WEBPACK_IMPORTED_MODULE_25__/* .useIsServer */ .w)();
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_22__/* .useProductScoreQuery */ .PjV)({
        variables: {
            id: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id
        },
        pause: !(masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) || !_$isServer || !reviewsEnabled
    }), 1), productScoreResult = ref5[0];
    var productScore = (ref = productScoreResult.data) === null || ref === void 0 ? void 0 : ref.productScore;
    if (!masterProduct || !variation || !(variation === null || variation === void 0 ? void 0 : (ref1 = variation.configureID) === null || ref1 === void 0 ? void 0 : ref1.enabled) || !personalizationEnabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_15__["default"], {
            message: t("productCouldNotBeFound")
        });
    }
    var ref6;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(hooks_useProductCustomization__WEBPACK_IMPORTED_MODULE_18__/* .ProductCustomizationProvider */ .V, {
            variation: variation,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_PageHead__WEBPACK_IMPORTED_MODULE_11__/* .PageHead */ .y, {
                    title: "".concat((masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name) || decodeURIComponent(router.query.model).replace(/-/g, " "), " | PUMA"),
                    description: (ref6 = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.description) !== null && ref6 !== void 0 ? ref6 : "",
                    noIndex: true,
                    noIndexFollow: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_InjectedScript__WEBPACK_IMPORTED_MODULE_24__/* .InjectedScript */ .D, {
                    type: "application/ld+json",
                    script: JSON.stringify((0,utils_object__WEBPACK_IMPORTED_MODULE_27__/* .avoidEmptyProperties */ ._h)({
                        "@context": "http://schema.org",
                        "@type": "Product",
                        name: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name,
                        sku: variation === null || variation === void 0 ? void 0 : variation.ean,
                        color: variation === null || variation === void 0 ? void 0 : variation.name,
                        description: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.description,
                        model: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id,
                        brand: {
                            "@type": "Brand",
                            name: (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.brand) || "PUMA"
                        },
                        logo: "https://".concat(host, "/assets/logo-puma-black.png"),
                        image: variation === null || variation === void 0 ? void 0 : variation.images.map(function(x) {
                            return x.href;
                        }),
                        offers: {
                            "@type": "Offer",
                            price: (variation === null || variation === void 0 ? void 0 : variation.salePrice) || (variation === null || variation === void 0 ? void 0 : variation.price),
                            priceCurrency: currency.code,
                            availability: "http://schema.org/InStock",
                            priceValidUntil: variation === null || variation === void 0 ? void 0 : variation.validUntil,
                            url: !_$isServer ? window.location.href : router.asPath,
                            seller: {
                                "@type": "Corporation",
                                name: "PUMA"
                            }
                        },
                        aggregateRating: productScore && Number(productScore.amount) > 0 ? {
                            "@type": "AggregateRating",
                            ratingValue: productScore.rating,
                            reviewCount: productScore.amount,
                            bestRating: 5,
                            worstRating: 1
                        } : undefined,
                        review: ((productScore === null || productScore === void 0 ? void 0 : (ref2 = productScore.reviews) === null || ref2 === void 0 ? void 0 : ref2.nodes) || []).map(function(review) {
                            return {
                                "@type": "Review",
                                author: {
                                    "@type": "Person",
                                    name: review.nickname
                                },
                                datePublished: review.date,
                                name: review.title,
                                reviewBody: review.text,
                                reviewRating: {
                                    "@type": "Rating",
                                    ratingValue: review.rating,
                                    bestRating: 5,
                                    worstRating: 1
                                }
                            };
                        })
                    }))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Page__WEBPACK_IMPORTED_MODULE_9__/* .Page */ .T, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mobile:pb-4 tablet:pb-6 desktop:pb-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_pages_ProductDetailsPages__WEBPACK_IMPORTED_MODULE_14__/* .ProductBreadcrumb */ .Sl, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "flex flex-col space-y-4 sm:space-y-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_pages_ProductDetailsPages__WEBPACK_IMPORTED_MODULE_14__/* .AddToCartErrorMessage */ .S4, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_pages_ProductDetailsPages__WEBPACK_IMPORTED_MODULE_14__/* .ProductPersonalise */ .UT, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_SanityContentSlot__WEBPACK_IMPORTED_MODULE_23__/* .SanityContentSlot */ .D, {
                                    items: content === null || content === void 0 ? void 0 : content.aboveProductStory,
                                    slotId: "aboveProductStory",
                                    documentId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id
                                }),
                                (variation === null || variation === void 0 ? void 0 : variation.productStory) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ProductStory__WEBPACK_IMPORTED_MODULE_16__/* .ProductStory */ .F, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, variation.productStory), {
                                    additionalContentSections: content === null || content === void 0 ? void 0 : content.ProductStoryAdditionalContentSlot,
                                    documentId: content === null || content === void 0 ? void 0 : content._id,
                                    slotId: "ProductStoryAdditionalContentSlot"
                                })),
                                (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_PixleeProductWidget__WEBPACK_IMPORTED_MODULE_17__/* .PixleeProductWidget */ .H, {
                                    skuId: masterProduct.id
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_SanityContentSlot__WEBPACK_IMPORTED_MODULE_23__/* .SanityContentSlot */ .D, {
                                    items: content === null || content === void 0 ? void 0 : content.belowProductStory,
                                    slotId: "belowProductStory",
                                    documentId: content === null || content === void 0 ? void 0 : content._id
                                })
                            ]
                        }),
                        isMiniCartVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_MiniCart__WEBPACK_IMPORTED_MODULE_20__/* .MiniCart */ .pp, {})
                    ]
                })
            ]
        })
    });
};
var Pdp = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(hooks_usePdp__WEBPACK_IMPORTED_MODULE_12__/* .PdpProvider */ .R, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Personalise, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, props))
    });
};
if (utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .isServer */ .sk) {
    Pdp.getInitialProps = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)(function(context) {
            var ref, ref1, ref2, id, req, country, siteConfig, personalizationEnabled, data, _tmp, _tmp1, pdpQuery, _tmp2, masterProduct, variations, ref3, categoryByIdQuery, _tmp3, categoryResult, categoryById, breadcrumbLinks, _tmp4, redirectPromises, desiredSwatch, _tmp5, variation, _tmp6, _tmp7;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_31__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = context.query.id;
                        req = context.req;
                        country = (0,utils_locale__WEBPACK_IMPORTED_MODULE_8__/* .parseRequestUrl */ .VJ)(req).country;
                        siteConfig = sites__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z[country.toUpperCase()];
                        personalizationEnabled = siteConfig === null || siteConfig === void 0 ? void 0 : (ref = siteConfig.staticFeatures) === null || ref === void 0 ? void 0 : ref.personalizationEnabled;
                        if (!isVariantId(id)) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            context.urqlClient.query(gql_queries_product__WEBPACK_IMPORTED_MODULE_3__/* .VARIANT_QUERY */ .YE, (_tmp.id = id, _tmp)).toPromise()
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (!(data === null || data === void 0 ? void 0 : data.variant) || !personalizationEnabled) {
                            if (context.res) context.res.statusCode = 404;
                        }
                        _tmp1 = {};
                        return [
                            2,
                            _tmp1
                        ]; // Fall through to allow client-side 404 page to render
                    case 2:
                        _tmp2 = {};
                        return [
                            4,
                            context.urqlClient.query(_generated_graphql__WEBPACK_IMPORTED_MODULE_22__/* .PdpDocument */ ._y, (_tmp2.id = id, _tmp2)).toPromise()
                        ];
                    case 3:
                        pdpQuery = _state.sent();
                        masterProduct = pdpQuery === null || pdpQuery === void 0 ? void 0 : (ref1 = pdpQuery.data) === null || ref1 === void 0 ? void 0 : ref1.product;
                        variations = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations;
                        if (!(masterProduct && masterProduct.primaryCategoryId)) return [
                            3,
                            6
                        ];
                        _tmp3 = {};
                        categoryByIdQuery = context.urqlClient.query(gql_queries_category__WEBPACK_IMPORTED_MODULE_4__/* .CATEGORY_BY_ID_QUERY */ .M, (_tmp3.id = masterProduct.primaryCategoryId, _tmp3));
                        return [
                            4,
                            categoryByIdQuery.toPromise()
                        ];
                    case 4:
                        categoryResult = _state.sent();
                        categoryById = (ref3 = categoryResult.data) === null || ref3 === void 0 ? void 0 : ref3.categoryById;
                        if (!categoryById) return [
                            3,
                            6
                        ];
                        _tmp4 = {};
                        breadcrumbLinks = (0,utils_breadcrumbRedirects__WEBPACK_IMPORTED_MODULE_5__/* .createProductBreadcrumbLinks */ .A2)((_tmp4.categoryById = categoryById, _tmp4.productName = masterProduct.name, _tmp4.productLink = "pd/".concat(context.query.model, "/").concat(context.query.id), _tmp4.isPersonalizing = true, _tmp4));
                        redirectPromises = (0,utils_breadcrumbRedirects__WEBPACK_IMPORTED_MODULE_5__/* .fetchBreadcrumbRedirectPromises */ .VD)(context.urqlClient, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(breadcrumbLinks));
                        // Execute all redirect promises
                        return [
                            4,
                            Promise.all(redirectPromises)
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        desiredSwatch = context.query.swatch || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations[0].colorValue);
                        _tmp5 = {};
                        if (!masterProduct || (variations === null || variations === void 0 ? void 0 : variations.length) === 0) {
                            if (context.res) context.res.statusCode = 404;
                            return [
                                2,
                                _tmp5
                            ]; // Fall through to allow client-side 404 page to render
                        }
                        variation = desiredSwatch ? variations === null || variations === void 0 ? void 0 : variations.find(function(x) {
                            return x.colorValue === desiredSwatch;
                        }) : null;
                        _tmp6 = {};
                        if (!variation || !(variation === null || variation === void 0 ? void 0 : (ref2 = variation.configureID) === null || ref2 === void 0 ? void 0 : ref2.enabled) || !personalizationEnabled) {
                            if (context.res) context.res.statusCode = 404;
                            return [
                                2,
                                _tmp6
                            ]; // Fall through to allow client-side 404 page to render
                        }
                        _tmp7 = {};
                        return [
                            2,
                            (_tmp7.emptyProps = true, _tmp7)
                        ];
                }
            });
        });
        return function(context) {
            return _ref.apply(this, arguments);
        };
    }();
}
/* harmony default export */ __webpack_exports__["default"] = (Pdp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9372,1489,6666,9294,2042,6740,769,9690,1061,5656,2026,4878,1924,9201,6346,9774,2888,179], function() { return __webpack_exec__(48625); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);